import { CoreDiProject, DiProject } from "@spawn/core";
import { CoreAssetsDiProject } from "@spawn/core-assets";
import { FreegamesDiProject } from "@spawn/freegames";
import { GoldenBonusDiProject } from "@spawn/golden-bonus";
import { ModernUiDiProject } from "@spawn/modern-ui";
import { NudgingDiProject } from "@spawn/nudge";
import { RevealDiProject } from "@spawn/reveal";
import { AutoplayController, LaglessGenerator, SlotMachineDiProject } from "@spawn/slot-machine";
import { NrgLaglessGenerator } from "./lagless/customLaglessGenerator";
import { NrgAutoplayController } from "./services/autoplayController";
import { NudgeUpService } from "./services/nudgeUpService";
import { ReelsetService } from "./services/reelsetService";
import { UncoverTierService } from "./services/uncoverTierService";
import { FGViewUtils } from "./views/freegames/fgViewUtils";

/**
 * Base of the game DI projects: adds the shared services. A game project extends this class,
 * calls `super.configure()` and then registers its own classes, at least
 * `this.override(CoreSymbolService, SymbolService)`.
 */
export abstract class NrgGameDiProject extends DiProject {
	/**
	 * Make sure to include all the extended projects that `createProjectBuilder` configures.
	 */
	public static readonly extendedProjects = [
		ModernUiDiProject,
		SlotMachineDiProject,
		CoreDiProject,
		CoreAssetsDiProject,
		RevealDiProject,
		NudgingDiProject,
		GoldenBonusDiProject,
		FreegamesDiProject,
	];

	public override configure(): void {
		this.add(FGViewUtils);
		this.add(NudgeUpService);
		this.add(ReelsetService);
		this.add(UncoverTierService);

		this.override(AutoplayController, NrgAutoplayController);
		this.override(LaglessGenerator, NrgLaglessGenerator);
	}
}
